"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elevationPalette = exports.elevationChildrenPalette = exports.elevation = void 0;
var _constants = require("../palette/constants");
/** Dark mode palette overrides for an elevated surface */
const elevationPalette = {
  1: _constants.elevation1Palette.dark,
  2: _constants.elevation2Palette.dark
};

/** Dark mode palette overrides for the children of an elevated surface */
/** secondary - Match elevated surface background so pressable cards with secondary buttons appear as a single surface. */
/** line - Increase brightness of lines in level2 so they appear closer to light source. */
exports.elevationPalette = elevationPalette;
const elevationChildrenPalette = {
  1: _constants.elevation1ChildrenPalette.dark,
  2: _constants.elevation2ChildrenPalette.dark
};
exports.elevationChildrenPalette = elevationChildrenPalette;
const sharedStyles = {
  shadowColor: '#000000',
  shadowOffset: {
    width: 0,
    height: 8
  }
};
const elevation = {
  1: Object.assign({}, sharedStyles, {
    shadowOpacity: 0.02,
    shadowRadius: 12
  }),
  2: Object.assign({}, sharedStyles, {
    shadowOpacity: 0.12,
    shadowRadius: 24
  })
};
exports.elevation = elevation;